import { styled, alpha } from '@mui/material/styles';
import { Box, Button } from '@mui/material';

export const MainContainer = styled(Box)({
  display: 'flex',
  // flex:1 + minHeight:0 bounds this to the space left by the modal header/progress
  // bar so the inner columns scroll instead of the content being pushed off-screen
  // and clipped at higher zoom levels (height:100% grew to content size).
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
});

export const LeftColumn = styled(Box)({
  flex: 1,
  padding: '24px',
  overflow: 'auto',
});

export const RightColumn = styled(Box)(({ theme }) => ({
  width: 400,
  padding: '24px',
  backgroundColor:
    theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.grey[50],
  borderLeft: theme.palette.mode === 'dark' ? `1px solid ${theme.palette.divider}` : 'none',
  overflow: 'auto',
}));

export const ActionsBox = styled(Box)({
  space: 2,
});

export const BackButton = styled(Button)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  bgcolor: theme.palette.mode === 'dark' ? theme.palette.action.hover : theme.palette.grey[100],
  color: theme.palette.text.primary,
  borderColor: theme.palette.divider,
  '&:hover': {
    bgcolor:
      theme.palette.mode === 'dark'
        ? alpha(theme.palette.common.white, 0.12)
        : theme.palette.grey[200],
    borderColor: theme.palette.divider,
  },
  transition: 'all 0.2s',
  '&:disabled': {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.action.disabled,
    borderColor: theme.palette.divider,
  },
}));

export const ConfirmButton = styled(Button)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  background: 'linear-gradient(to right, rgb(6, 182, 212), rgb(16, 185, 129))',
  color: 'white',
  '&:hover': {
    background: 'linear-gradient(to right, rgb(8, 145, 178), rgb(14, 159, 104))',
  },
  transition: 'all 0.2s',
  '&:disabled': {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled,
    background: theme.palette.action.disabledBackground,
  },
}));

export const LossWarningList = styled('ul')({
  margin: 0,
  paddingLeft: '16px',
});

export const InfoList = styled('ul')({
  margin: 0,
  paddingLeft: '16px',
});
